var map = {
	"./bg/strings.json": 1928,
	"./cs/strings.json": 1929,
	"./da/strings.json": 1930,
	"./de/strings.json": 1931,
	"./el/strings.json": 1932,
	"./es-ES/strings.json": 1933,
	"./es-LA/strings.json": 1934,
	"./et/strings.json": 1935,
	"./fi/strings.json": 1936,
	"./fr-CA/strings.json": 1937,
	"./fr/strings.json": 1938,
	"./it/strings.json": 1939,
	"./lt/strings.json": 1940,
	"./lv/strings.json": 1941,
	"./nl/strings.json": 1942,
	"./no/strings.json": 1943,
	"./pl/strings.json": 1944,
	"./pseudo/strings.json": 1945,
	"./pt/strings.json": 1946,
	"./ro/strings.json": 1947,
	"./sk/strings.json": 1948,
	"./sl/strings.json": 1949,
	"./sv/strings.json": 1950,
	"./zh-CN/strings.json": 1951,
	"./zh-TW/strings.json": 1952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1927;